'use client';

import { useEffect } from 'react';

/**
 * Component that automatically registers the service worker when the app starts
 * This ensures the service worker is available for push notifications
 */
export const ServiceWorkerRegistration: React.FC = () => {
  useEffect(() => {
    const registerServiceWorker = async () => {
      try {
        // Check if service workers are supported
        if (!('serviceWorker' in navigator)) {
          console.warn('Service workers are not supported in this browser');
          return;
        }

        // Dynamically import the push notification service to avoid SSR issues
        const { pushNotificationService } = await import('@/lib/push-notifications');

        // Register service worker (basic registration without push manager requirements)
        const registered = await pushNotificationService.registerServiceWorker();

        if (registered) {
//          console.log('Service worker registered successfully on app startup');
        } else {
          console.warn('Service worker registration failed on app startup');
        }
      } catch (error) {
        console.error('Error registering service worker on app startup:', error);
      }
    };

    registerServiceWorker();
  }, []);

  // This component doesn't render anything
  return null;
};
